import React, { useState } from "react";
import { useSelector } from "react-redux";
import ItemProduct from "../../Common/ItemProduct";
import Order from "../../Common/Order";
import OtherUser from "../../Common/OtherUser";
import Payment from "../../Common/Payment";
import UserBuyer from "../../Common/UserBuyer";
import TicketList from "../../Common/TicketList";

const Index = ({ data, role, updateAll, setUpdateAll,isAbsent,appModal }) => {
  const { user } = useSelector((state) => state);
  const [showTicket, setShowTicket] = useState(false)

  // if (user?.role == "user" || user?.role == "owner") {
  //   !showTicket &&
  //     setShowTicket(true)
  // }
  if (role) {
    return (
      <>
        <div className="mt-4">
          <ItemProduct
            details={{
              ...data.product.reserve_details,
              ...data.product.reserve_time,
              item_name: data.product.item_name,
            }}
          />
          <Order order={data.order} />
          <Payment payment={data.peyment} />
          {user.role == "manager" && data?.order?.Client && <UserBuyer userbuyer={data.order.Client} />}
          {/* <OtherUser other={data.otheruser} /> */}

          <TicketList appModal={appModal} isAbsent={isAbsent} ticketData={data?.product?.reserve_product} role={role} updateAll={updateAll} setUpdateAll={setUpdateAll} />
        </div>
      </>
    );
  }
  return (
    <div className="mt-4">
      <ItemProduct
        details={{
          ...data.product.reserve_details,
          ...data.product.reserve_time,
          item_name: data.product.item_name,
        }}
      />
      <Order order={data.order} />
      <Payment payment={data.peyment} />

      {user.role != "user" ? <UserBuyer userbuyer={data.user_buyer} /> : <></>}
      {/* <OtherUser other={data.otheruser} /> */}
      {/* {showTicket && */}
        <TicketList appModal={appModal} isAbsent={isAbsent} ticketData={data?.product?.reserve_product} role={user.role} updateAll={updateAll} setUpdateAll={setUpdateAll} />
      {/* } */}

    </div>
  );
};

export default Index;
